/**
 * Tiny cpode:
 * This code is being pulled from https://github.com/Textalk/angular-schema-form-tinymce
 *
 * The problem with that project is that it is not active,
 * uses a dependency that is not active (tx-tinymce) and has no support for NPM.
 * The lack of NPM is the real deal breaker.
 *
 * TODO: I really don't like this implementation and when time permits I want to dig in and
 * make this right.  For now, we hack.
 *
 * PBall: added some hackery on 5/24/2016
 * converted this file to contain all addons and overrides on 8/22/2017
 */

angular.module('schemaFormAddons', [
  'schemaForm',
  'ui.tinymce'
])
.config([
  'schemaFormDecoratorsProvider',
  function (schemaFormDecoratorsProvider) {
    'use strict';

    // PB - This doesn't seem to be hit or used. Commenting out for now,
    // will remove assuming nothing breaks.

    // var wysiwyg = function (name, schema, options) {
    //   var f;
    //   if (schema.type === 'string' && schema.format === 'html') {
    //     f = schemaFormProvider.stdFormObj(name, schema, options);
    //     f.key = options.path;
    //     f.type = 'wysiwyg';
    //     options.lookup[sfPathProvider.stringify(options.path)] = f;
    //   }
    //   return f;
    // };

    // schemaFormProvider.defaults.string.unshift(wysiwyg);

    // Map templates to asf type
    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'wysiwyg',
      'components/authoring/schemaFormAddons/tinymce.html'
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'array',
        'components/authoring/schemaFormAddons/array.html'
    );
  }
]);
